export const LOAD_CASHBACKS_LIST = "LOAD_CASHBACKS_LIST";
export const SET_CASHBACKS_PAGE = "SET_CASHBACKS_PAGE";
export const SET_CASHBACKS_PERPAGE = "SET_CASHBACKS_PERPAGE";
export const SET_CASHBACKS_TOTAL = "SET_CASHBACKS_TOTAL";
export const CASHBACKS_LOADING = "CASHBACKS_LOADING";
export const SET_CASHBACK = "SET_CASHBACK";
export const SET_CASHBACKS_FILTRO = "SET_CASHBACKS_FILTRO";
